import { initializeApp, getApps, FirebaseApp } from 'firebase/app'
import { getFirestore, Firestore } from 'firebase/firestore'
import { getMessaging, isSupported } from 'firebase/messaging'
import { getAuth, Auth } from 'firebase/auth'

const firebaseConfig = {
  apiKey:            import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain:        import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId:         import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket:     import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId:             import.meta.env.VITE_FIREBASE_APP_ID,
}

let app: FirebaseApp | null = null
export let firestore: Firestore | null = null
export let firebaseAuth: Auth | null = null

try {
  app = getApps().length === 0 ? initializeApp(firebaseConfig) : getApps()[0]
  firestore = getFirestore(app)
  firebaseAuth = getAuth(app)
} catch (e) {
  console.warn('Firebase init failed — chat and push notifications disabled', e)
}

export const getMessagingInstance = async () => {
  if (!app) return null
  try {
    const supported = await isSupported()
    return supported ? getMessaging(app) : null
  } catch {
    return null
  }
}

export default app
